import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Spinner } from 'component/Spinner'
import { Typo } from 'component/Typo'
import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Photo } from 'page/ProfileScreen/Selfies/Photo'
import css from 'page/ProfileScreen/Selfies/StandCameraInput.module.scss'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const StandCameraInput = observer(() => {
  const { selfies, camera, num } = store.profile.common
  const selfie = selfies[num]
  const picture = selfie.url
  const error = camera.error || selfie.error

  const className = clsx(css.button, error && css.error)

  useEffectOnce(() => {
    if (opt.camera) selfies[1].clear()
    else selfies[num].clear()
  })

  useEffectOnce(() => {
    return () => camera.stop()
  })

  const onVideo = useLatestCallback((element: HTMLVideoElement) => {
    camera.element = element
    void camera.start()
  })

  return (
    <Space className={className} center data-camera-input>
      <Space className={css.circle} oh>
        <svg className={css.dash} viewBox="0 0 480 480" preserveAspectRatio="xMidYMid meet" aria-hidden>
          <circle cx="240" cy="240" r="237" />
        </svg>
        <Space className={css.inner} center>
          {!selfie.src && (
            <video
              key={camera.key}
              ref={onVideo}
              className={clsx(
                css.video,
                css[`turn${opt.turn}`],
                opt.mirror && camera.isFrontCamera && css.mirror,
              )}
            />
          )}
          {selfie.src && <Photo selfie={selfie} />}
          {(camera.starting || camera.processing) && (
            <div className={css.loading}>
              <Spinner />
            </div>
          )}
        </Space>
      </Space>
      {!!camera.seconds && (
        <Space className={css.countdown} center>
          <Typo size={256} bold one>
            {camera.seconds.toFixed()}
          </Typo>
        </Space>
      )}
    </Space>
  )
})
